import { RegisterClass } from '@memberjunction/global';
import { BaseUserMenu } from '@memberjunction/ng-explorer-core';
import { UserMenuItem } from '@memberjunction/ng-explorer-core';

@RegisterClass(BaseUserMenu)
export class SoundPostUserMenu extends BaseUserMenu {
  override GetMenuItems(): UserMenuItem[] {
    return super.GetMenuItems().filter(item => item.id !== 'about');
  }
}
